import { render } from "./ListHeader.vue?vue&type=template&id=476e29b3"
import script from "./ListHeader.vue?vue&type=script&lang=js"
export * from "./ListHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__